import {LOCATE_SHOW_MENU} from "../types";

const showMenu= (visible) => {
  return ({type: LOCATE_SHOW_MENU, payload: {visibleMenu: visible}});
};

export default showMenu;